import * as THREE from 'three'

const CHARACTER_DIRECTION_EPSILON = 1e-6

export const MOVE_FORWARD_CODES = ['KeyW', 'ArrowUp']
export const MOVE_BACKWARD_CODES = ['KeyS', 'ArrowDown']
export const MOVE_LEFT_CODES = ['KeyA', 'ArrowLeft']
export const MOVE_RIGHT_CODES = ['KeyD', 'ArrowRight']
export const RUN_CODES = ['ShiftLeft', 'ShiftRight']
export const JUMP_CODES = ['Space']

export function createAimDirection(yaw: number, pitch: number): THREE.Vector3 {
  const planar = Math.cos(pitch)
  return new THREE.Vector3(
    Math.cos(yaw) * planar,
    Math.sin(yaw) * planar,
    Math.sin(pitch)
  ).normalize()
}

export function createPlanarForward(yaw: number): THREE.Vector3 {
  return new THREE.Vector3(Math.cos(yaw), Math.sin(yaw), 0).normalize()
}

export function createPlanarRight(yaw: number): THREE.Vector3 {
  const forward = createPlanarForward(yaw)
  return new THREE.Vector3(forward.y, -forward.x, 0).normalize()
}

export function resolvePlanarYawFromDirection(
  direction: THREE.Vector3,
  fallbackYaw: number
): number {
  const planarDirection = direction.clone()
  planarDirection.z = 0
  if (planarDirection.lengthSq() <= CHARACTER_DIRECTION_EPSILON) {
    return fallbackYaw
  }

  return Math.atan2(planarDirection.y, planarDirection.x)
}

export function isCharacterInputKey(code: string): boolean {
  return (
    MOVE_FORWARD_CODES.includes(code) ||
    MOVE_BACKWARD_CODES.includes(code) ||
    MOVE_LEFT_CODES.includes(code) ||
    MOVE_RIGHT_CODES.includes(code) ||
    RUN_CODES.includes(code) ||
    JUMP_CODES.includes(code)
  )
}
